export default __webpack_public_path__ + "static/media/ajla_logo.a5a193a1.png";